import { Platform } from 'react-native';

/**
 * Best-effort removal of temporary enrollment captures.
 * Never logs the URI in production.
 */
export async function deleteTemporaryImage(uri: string | null | undefined) {
  if (!uri) return false;
  try {
    // Optional native helper when linked; ignore when unavailable.
    const RNFS = require('react-native-fs') as {
      exists: (path: string) => Promise<boolean>;
      unlink: (path: string) => Promise<void>;
    };
    const path = uri.startsWith('file://') ? uri.replace('file://', '') : uri;
    if (await RNFS.exists(path)) {
      await RNFS.unlink(path);
      return true;
    }
  } catch {
    // Cache-scoped picker files are cleaned by the OS when unlink is unavailable.
  }
  return false;
}

/**
 * Frees a camera capture once nothing will upload it again: revokes a web
 * blob URL, otherwise removes the temporary file.
 */
export async function releaseCapturedImage(uri: string | null | undefined) {
  if (!uri) return;
  if (Platform.OS === 'web' && uri.startsWith('blob:')) {
    URL.revokeObjectURL(uri);
    return;
  }
  await deleteTemporaryImage(uri).catch(() => undefined);
}
